

<div [@slideInOut]="animationState" [ngClass]="{'welcome-back': isWelcome}" class="no-internet-bar line-height-1 text-sm">
  <div *ngIf="!isConnected">You are currently offline. Some features may not be available.</div>
  <div *ngIf="isWelcome">Welcome back! You are online.</div>
</div>